export default __webpack_public_path__ + "static/gatsby_github_settings-bd356c2b2c6778578e1cc02f6654d5fd.png";